import { inject, Injectable, WritableSignal } from '@angular/core';
import { TNil } from '@app/app.interface';
import { DateUtilitiesService } from '@utilities/date-utilities.service';
import { differenceInSeconds } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class StreamDetailsService {
  private readonly dateUtils = inject(DateUtilitiesService);

  public getSeekTimeInSeconds(seekTimestampInUtc: string | TNil, videoStartInUtc: string | null): number | null {
    if (!videoStartInUtc || !seekTimestampInUtc) {
      return null;
    }

    const streamStartDate = this.dateUtils.parseDateTimeFromApi(videoStartInUtc);
    const timestampDate = this.dateUtils.parseDateTimeFromApi(seekTimestampInUtc);
    const diffInSeconds = differenceInSeconds(timestampDate, streamStartDate);

    if (isNaN(diffInSeconds) || diffInSeconds < 0) {
      return null;
    }

    return diffInSeconds;
  }

  public seekToTimestamp(
    seekTimestampInUtc: string | TNil,
    videoStartInUtc: string | null,
    seekTime: WritableSignal<number | null>,
  ): void {
    const diffInSeconds = this.getSeekTimeInSeconds(seekTimestampInUtc, videoStartInUtc);

    if (diffInSeconds === null) {
      return;
    }

    seekTime.set(null);

    setTimeout(() => {
      seekTime.set(diffInSeconds);
    });
  }
}
